'use client';

import { ReactNode } from 'react';

import { useKnowledgeSearch } from '../../utils/knowledge/useKnowledgeSearch';
import { KnowledgeLocale } from '../../utils/knowledge/knowledgeCopy';
import { KnowledgeArticle, KnowledgeChannel } from '../../utils/knowledge/types';
import { KnowledgeCentreLayout } from './KnowledgeCentreLayout';

interface KnowledgeCentreWithSearchProps {
  channel: KnowledgeChannel;
  locale: KnowledgeLocale;
  title: string;
  description?: string;
  articles: KnowledgeArticle[];
  children: ReactNode;
}

export const KnowledgeCentreWithSearch = ({
  channel,
  locale,
  title,
  description,
  articles,
  children,
}: KnowledgeCentreWithSearchProps) => {
  const { query, setQuery, results, hasQuery } = useKnowledgeSearch(articles);

  return (
    <KnowledgeCentreLayout
      channel={channel}
      locale={locale}
      title={title}
      description={description}
      searchQuery={query}
      onSearchQueryChange={setQuery}
      searchResults={
        hasQuery
          ? results.map((article) => ({ urlName: article.urlName, title: article.title }))
          : []
      }
    >
      {!hasQuery ? children : null}
    </KnowledgeCentreLayout>
  );
};
